import { PlatformFSContext } from './core/context'
import { type MoveDialogProps, useMoveCore } from './core/hooks/useMove'

export type { MoveDialogProps }

const platformContext = new PlatformFSContext()

export function useMove(domain: number) {
  return useMoveCore(platformContext, domain)
}
